export default __webpack_public_path__ + "static/charlie-gunyon-eabd13b3bfc323985f6e5f562f90bf2b.jpg";